.screen-container {
  position: relative;
  padding: 32px 5px;
  display: flex;
  flex-direction: column;
  z-index: 102;
  overflow: auto;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.is-mobile-viewport .screen-container {
  max-height: var(--mobile-max-height);
}

.content-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 430px;
  height: auto;
  align-self: center;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
}
.content-inner {
  flex-grow: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}
.policy-section {
  padding: 0 20px;
}
.copy-container,
.bottom-section {
  display: flex;
  flex-direction: column;
}

.copy-container {
  padding: 0 20px 0;
  gap: 12px;
  justify-content: flex-end;
}

.bottom-section {
  gap: 16px;
  padding: 0 20px 0;
}

.form {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.inputs-container {
  display: flex;
  flex-flow: wrap;
  align-self: center;
  justify-content: center;
  width: 100%;
}

.error {
  display: block;
  font-size: 14px;
  color: red;
  padding: 5px 0px;
  text-align: center;
}

.cta-wrapper {
  width: 30%;
}

.cta {
  width: 100%;
  height: 51px;
  border-style: solid;
  border-width: var(--submit-button-border-width, 0px);
  border-color: var(--submit-button-border-color, transparent);
  background-color: var(--submit-button-bg-color);
  border-radius: var(--submit-button-border-radius);
  cursor: pointer;
  padding: 0;
  white-space: pre-wrap;
}

.title,
.body {
  overflow-wrap: break-word;
  white-space: pre-wrap;
}

.title h1 {
  margin: 0;
  font-weight: normal;
  width: 100%;
}

.body p {
  margin: 0;
  width: 100%;
}

.input-container {
  flex: 1;
}

.privacy-policy-container {
  margin: 4px 0 0;
  white-space: pre-wrap;
}

.privacy-policy-container p {
  margin: 0;
}

.open-tracking-consent-wrapper {
  display: block;
}

.open-tracking-consent-label {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
  white-space: pre-wrap;
}

.open-tracking-consent-label input[type='checkbox'] {
  flex: 0 0 auto;
  margin: 2px 0 0;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.open-tracking-consent-label span p {
  margin: 0;
}

.is-mobile-viewport .content-area {
  width: 100% !important;
}

.is-mobile-viewport .body {
  margin-bottom: 0;
}

.is-mobile-viewport .content-area .input,
.is-mobile-viewport .content-area .cta-wrapper,
.has-custom-fields .input,
.has-custom-fields .cta-wrapper {
  width: 100% !important;
}

.inputs-container.has-custom-fields,
.is-mobile-viewport .inputs-container {
  gap: 8px;
}

.absolute-input {
  position: relative;
}

.absolute-input .inputs-container {
  position: absolute;
  left: 20px;
  width: calc(100% - 40px);
  bottom: var(--emailInputOffset);
}

.sc-om-default-layout .cta-next-to-email.inputs-container {
  flex-direction: row;
  flex-flow: row nowrap;
  align-items: center;
  gap: 0;
}

.sc-om-default-layout .cta-next-to-email .input-container {
  flex: 1 1 auto;
}

.sc-om-default-layout .cta-next-to-email .cta-wrapper {
  width: auto !important;
  min-width: 120px;
  margin: 0;
}

.sc-om-default-layout .cta-next-to-email .sc-om-custom-fields-h {
  width: 0 !important;
}

/* Border radius adjustments when button is next to input */
.sc-om-default-layout .input-container + .cta-wrapper > button {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.sc-om-default-layout .input-container:has(+ .cta-wrapper) > input {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
